/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SalesOrderItemAvailabilitySummary } from './SalesOrderItemAvailabilitySummary';
import {
    SalesOrderItemAvailabilitySummaryFromJSON,
    SalesOrderItemAvailabilitySummaryFromJSONTyped,
    SalesOrderItemAvailabilitySummaryToJSON,
    SalesOrderItemAvailabilitySummaryToJSONTyped,
} from './SalesOrderItemAvailabilitySummary';

/**
 * 
 * @export
 * @interface PagedAndSyncedResultSalesOrderItemAvailabilitySummary
 */
export interface PagedAndSyncedResultSalesOrderItemAvailabilitySummary {
    /**
     * 
     * @type {Array<SalesOrderItemAvailabilitySummary>}
     * @memberof PagedAndSyncedResultSalesOrderItemAvailabilitySummary
     */
    content: Array<SalesOrderItemAvailabilitySummary>;
    /**
     * 
     * @type {number}
     * @memberof PagedAndSyncedResultSalesOrderItemAvailabilitySummary
     */
    totalElements: number;
    /**
     * 
     * @type {number}
     * @memberof PagedAndSyncedResultSalesOrderItemAvailabilitySummary
     */
    totalPages: number;
    /**
     * 
     * @type {Date}
     * @memberof PagedAndSyncedResultSalesOrderItemAvailabilitySummary
     */
    lastSyncedAt?: Date;
}

/**
 * Check if a given object implements the PagedAndSyncedResultSalesOrderItemAvailabilitySummary interface.
 */
export function instanceOfPagedAndSyncedResultSalesOrderItemAvailabilitySummary(value: object): value is PagedAndSyncedResultSalesOrderItemAvailabilitySummary {
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('totalElements' in value) || value['totalElements'] === undefined) return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined) return false;
    return true;
}

export function PagedAndSyncedResultSalesOrderItemAvailabilitySummaryFromJSON(json: any): PagedAndSyncedResultSalesOrderItemAvailabilitySummary {
    return PagedAndSyncedResultSalesOrderItemAvailabilitySummaryFromJSONTyped(json, false);
}

export function PagedAndSyncedResultSalesOrderItemAvailabilitySummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagedAndSyncedResultSalesOrderItemAvailabilitySummary {
    if (json == null) {
        return json;
    }
    return {
        
        'content': ((json['content'] as Array<any>).map(SalesOrderItemAvailabilitySummaryFromJSON)),
        'totalElements': json['totalElements'],
        'totalPages': json['totalPages'],
        'lastSyncedAt': json['lastSyncedAt'] == null ? undefined : (new Date(json['lastSyncedAt'])),
    };
}

export function PagedAndSyncedResultSalesOrderItemAvailabilitySummaryToJSON(json: any): PagedAndSyncedResultSalesOrderItemAvailabilitySummary {
    return PagedAndSyncedResultSalesOrderItemAvailabilitySummaryToJSONTyped(json, false);
}

export function PagedAndSyncedResultSalesOrderItemAvailabilitySummaryToJSONTyped(value?: PagedAndSyncedResultSalesOrderItemAvailabilitySummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': ((value['content'] as Array<any>).map(SalesOrderItemAvailabilitySummaryToJSON)),
        'totalElements': value['totalElements'],
        'totalPages': value['totalPages'],
        'lastSyncedAt': value['lastSyncedAt'] == null ? value['lastSyncedAt'] : value['lastSyncedAt'].toISOString(),
    };
}

